<template>
  <div
    @mouseover="mouseEnter = openOrCloseDropDown()"
    @mouseleave="false"
    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
  >
    <dropdown-menu
      id="drop-menu-profile"
      v-model="mouseEnter"
      :right="true"
      transition="translate-fade-down"
    >
      <SUserAvatar
        :myUser="userData"
        size="x-medium"
        data-v-step="2"
        :isProfileAvatar="true"
      />
      <div slot="dropdown" class="my-drop scrollable-dropdown">
        <div class="swampum-dropdown-menu">
          <div class="swampum-drowpdown-menu--header">
            <p>ACCOUNT</p>
          </div>
          <div class="swampum-dropdown-menu--userame">
            <span>{{ userName || userData.firstName }}</span>
            <span>(@{{ profileUserName || userData.username }})</span>
          </div>

          <hr class="line-header" />

          <div class="swampum-dropdown-menu--links">
            <div class="swampum-dropdown-menu--link">
              <div class="swampum-dropdown-menu--pointsBalance">
                <router-link to="/s-app/points-history" data-cy="pointsBalanceAreaLink" @click.native="goToPoints">
                  <div class="swampum-dropdown-menu--pointsBalanceInfo">
                    <p>Points</p>
                    <div>
                      {{ getMyPointsBalance }}
                      <img class="mb-2" src="/img/Polygon_7.svg" alt="Swampum" width="10px" height="10px"/>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <div class="swampum-dropdown-menu--link">
              <div class="swampum-dropdown-menu--profile">
                <router-link :to="`/s-app/profile-page/${userId}/settings`" data-cy="profileLink" @click.native="goToInventory">
                  <p>
                    Profile <md-icon>person</md-icon>
                  </p>
                </router-link>
              </div>
            </div>

            <div class="swampum-dropdown-menu--link">
              <div class="swampum-dropdown-menu--profile">
                <router-link :to="`/s-app/profile-page/${userId}/`" data-cy="profileLink" @click.native="goToInventory">
                  <p>
                    Inventory <md-icon>inventory</md-icon>
                  </p>
                </router-link>
              </div>
            </div>

            <div class="swampum-dropdown-menu--link">
              <div class="swampum-dropdown-menu--inviteFriends">
                <router-link to="/s-app/invite-friends" data-cy="tbInviteFriend" @click.native="close">
                  <p>
                    Invite Friends <md-icon>group_add</md-icon>
                  </p>
                </router-link>
              </div>
            </div>

            <div class="swampum-dropdown-menu--link">
              <div class="swampum-dropdown-menu--profile">
                <router-link :to="`/s-app/profile-page/${userId}/wishlist`" data-cy="profileLink" @click.native="goToInventory">
                  <p>
                    Favorites <md-icon>favorite</md-icon>
                  </p>
                </router-link>
              </div>
            </div>

          </div>

          <hr class="line-header" />

          <div class="swampum-dropdown-menu--link">
            <a class="swampum-dropdown-menu--logout" @click.prevent="logout" data-cy="logoutButton">
              <span>Logout</span>
              <md-icon>logout</md-icon>
            </a>
          </div>

        </div>
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from '@innologica/vue-dropdown-menu';
import UserHelperVue from '@/mixins/UserHelper.vue';
import Auth from '@/modules/Auth.js';
import { mapActions } from 'vuex';
import SUserAvatar from '@/material-components/atoms/SUserAvatar';
import Global from '@/constants/Global';

export default {
  name: 'SHeaderProfileMenu',
  props: ['userId', 'userName', 'profileUserName'],
  components: {
    DropdownMenu,
    SUserAvatar
  },
  mixins: [UserHelperVue],
  data() {
    return {
      mouseEnter: false,
      show: false,
      auxReloadProfilePic: 0,
      userData: JSON.parse(localStorage.getItem('loggedUser'))
    };
  },
  methods: {
    close() {
      this.$emit('changeKey');
    },
    goToInventory() {
      // localStorage.setItem("loggedUser", JSON.stringify(this.loggedUser));
      this.$emit('changeKey');
    },
    goToPoints() {
      localStorage.setItem("pointsSection", "history");
      this.$emit('changeKey');
    },
    reloadUserHeaderImg() {
      this.auxReloadProfilePic++;
    },
    ...mapActions(['endSession']),
    logout() {
      sessionStorage.clear();
      this.endSession();
      Auth.deauthenticateUser();
      this.$parent.$parent.$parent.clearLastInteraction();
      localStorage.removeItem('user_id');
      this.$route.path !== '/' && this.$router.push('/');
      location.reload();
    },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    }
  },
  computed: {
    userHeaderImg() {
      const url = this.getUserImagePath(this.userData);
      return `${url}?t=${this.auxReloadProfilePic}`;
    },
    getMyPointsBalance() {
      if (this.userData) {
        return this.userData.points;
      }
      return 'User disconnected';
    }
  },
  watch: {
    // loggedUser() {
    //   this.userData = this.loggedUser;
    // },
  },
  created() {
    // if(this.userId === undefined || this.userName === undefined || this.profileUserName === undefined) {
    //   this.userData = JSON.parse(localStorage.getItem('loggedUser'))
    // }
  }
};
</script>

<style lang="scss" scoped>
.md-avatar {
  width: 45px !important;
  height: 45px !important;
}
.md-avatar::after {
  display: none;
}
.mouse-enter .md-button {
  background-color: white !important;
}
.md-button {
  border: 1px solid #e0e0e0;
  border-radius: 20px !important;
}
.mouse-leave .md-icon {
  color: $black !important;
}
.mouse-enter .md-icon {
  color: $black !important;
}
a span,
#header-icon {
  float: right;
}
a span {
  margin-right: 0.5rem;
}
</style>

<style lang="scss" scoped>
.scrollable-dropdown {
  max-height: 550px;
  overflow: scroll;
}
.username-profile {
  display: block;
  align-self: center;
  margin-left: 0 !important;
  margin-top: 0.5rem;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
  padding: 0.5rem;
}
.username-username {
  display: block;
  align-self: center;
  margin-left: 0 !important;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
  padding: 0.2rem;
  font-size: 1em;
}
#header-icon {
  color: $header-icon-color !important;
}
.line-header {
  width: 70%;
  color: rgba(0, 0, 0, 0.2);
}
.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.my-drop::before {
  position: absolute;
  content: '';
  top: 0;
  left: 176px;
  transform: translateY(-100%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid $primary;
}
.my-drop a {
  height: 30px;
}
</style>

<!-- Header drop menu style -->
<style lang="scss" scoped>
#drop-menu-profile .show {
  width: 210px !important;
  margin-top: 0.95em;
  margin-right: -3px;
  border: 1px solid $primary;
}
#drop-menu-profile a {
  color: $black !important;
  height: 40px;
  padding: 10px 25px 10px 10px;
  width: 99.5%;
}
#drop-menu-profile span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}
#drop-menu-profile a:active {
  background-color: $primary;
}
</style>

<style scoped lang="scss">
.swampum-dropdown-menu {
  width: 100%;
  min-width: 200px !important;
  height: 100%;
  padding: 0.5rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px
}

.swampum-drowpdown-menu--header {
  width: 100%;
  height: 100%;

  p {
    font-weight: bold;
    font-size: 16px;

    border-bottom: 2px solid $primary;
    margin: 0;
  }
}

.swampum-dropdown-menu--userame {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  span {
    font-size: 16px;
    font-weight: bold;
  }

}

.swampum-dropdown-menu--links {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.swampum-dropdown-menu--link {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.swampum-dropdown-menu--pointsBalance {
  width: 100%;
  height: 100%;

  border-radius: 0.75rem;
  background-color: $grey;
  margin: 0 1.25rem;
  padding: 0;
}

.swampum-dropdown-menu--profile, .swampum-dropdown-menu--inviteFriends {
  p {
    text-align: center;
    letter-spacing: 1.25px;
    margin: 0;
  }
}

.swampum-dropdown-menu--logout {
  width: 100%;
  height: 100%;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  span {
    width: 100%;
  }
}

.swampum-dropdown-menu--pointsBalanceInfo {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;

  p {
    letter-spacing: 1.25px;
    margin: 0;
  }

  div {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    font-weight: bold;
    font-size: 14px;
  }
}
</style>
